module.exports = __webpack_public_path__ + "static/media/carousel1.d7003af0.png";